import Breadcrumbs from "components/Common/Breadcrumb";
import AutoReloadList from "components/shared-components/AutoReload/AutoReloadList";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { env } from "configs/EnvironmentConfig";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_ARE,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_REPLACE,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  CLIENT_TYPE_CONST,
  TYPE_TRANSFER,
} from "constants/FormatDataContanst";
import {
  MODE_INVOICE_ACTION,
  TYPE_INVOICE_ANOTHER,
} from "constants/IssueInvoiceConstant";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { TENANT_CODE } from "constants/TennantConstant";
import { getResourceIdXML } from "helpers/form_helper";
import { getFileNameExcel, toastWarningIsAllStore } from "helpers/utils";
import jwt_decode from "jwt-decode";
import ErrorReleaseModal from "pages/DataFormatInvoice/modal/ErrorReleaseModal";
import HistoryTransferModal from "pages/DataFormatInvoice/modal/HistoryTransferModal";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import { getInvoiceStatus } from "pages/IssueInvoice/helper/functionHelper";
import CompareInvoiceModal from "pages/IssueInvoice/modal/CompareInvoiceModal";
import ConfirmActionInvoice from "pages/IssueInvoice/modal/ConfirmActionInvoice";
import ConfirmCancelInvoiceModal from "pages/IssueInvoice/modal/ConfirmCancelInvoiceModal";
import PDFViewModal from "pages/IssueInvoice/modal/PDFViewModal";
import SignHSMModal from "pages/IssueInvoice/modal/SignHSMModal";
import TypeSignDigitalModal from "pages/IssueInvoice/modal/TypeSignDigitalModal";
import VerifyPinUSBModal from "pages/IssueInvoice/modal/VerifyPinUSBModal";
import {
  COMMON_CONDITION_VISIBLE,
  getRowInvoiceReplaceAdjustInfo,
  issueInvoiceModeList,
  issueInvoicePageViewList,
  KHMSHDON,
} from "pages/IssueInvoice/utils";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  cancelIssueInvoice,
  deleteIssueInvoice,
  downloadXmlIssueInvoice,
  exportInvoiceWarehousesAgency,
  getCloneEnvoice,
  getDataLink,
  listInvoiceSymbol,
  listIssueInvoice,
  releaseIssueInvoice,
  resetAdjustIssueInvoice,
  resetBackupDataNew,
  resetCancelIssueInvoice,
  resetCloneEnvoice,
  resetDeleteIssueInvoice,
  resetDownloadXmlIssueInvoice,
  resetExportInvoiceWarehousesAgency,
  resetListInvoiceSymbol,
  resetListIssueInvoice,
  resetReleaseIssueInvoice,
  resetReplaceIssueInvoice,
  resetSetBuStoreHeader,
} from "store/actions";
import {
  AUTH_TOKEN,
  BU_STORE_HEADER,
  ROLE_EINVOICE_CUA_HANG,
} from "store/auth/login/actionTypes";
import {
  SET_BU_STORE_HEADER,
  SET_BU_STORE_HEADER_SUCCESS,
} from "store/dashboard/actionTypes";
import {
  ADJUST_ISSUE_INVOICE_FAIL,
  ADJUST_ISSUE_INVOICE_SUCCESS,
  CANCEL_ISSUE_INVOICE_FAIL,
  CANCEL_ISSUE_INVOICE_SUCCESS,
  DELETE_ISSUE_INVOICE_FAIL,
  DELETE_ISSUE_INVOICE_SUCCESS,
  DOWNLOAD_XML_ISSUE_INVOICE_FAIL,
  DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS,
  EXPORT_INVOICE_WAREHOUSES_AGENCY_FAIL,
  EXPORT_INVOICE_WAREHOUSES_AGENCY_SUCCESS,
  REPLACE_ISSUE_INVOICE_FAIL,
  REPLACE_ISSUE_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import DetailData from "./modal/DetailData";

const ListData = props => {
  const {
    filterList,
    pageView,
    title,
    titleManger,
    khhdonDefault,
    setKhhdonDefault,
    setPageView,
  } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["warehouseAgency"]);
  const { addToast } = useToasts();

  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    loadingList,
    errorList,
    list: issueInvoiceList,
    fileDownload,
    fileDownloadName,
    type,
    deleteInvoice,
    cancelInvoice,
    successClone,
    exportInvoiceWarehousesAgencyData,
    bkDataNew,
  } = issueInvoice;

  const invoiceSymbol = useSelector(state => state.invoiceSymbol);
  const { errorList: errorInvoiceSymbolList, list: invoiceSymbolList } =
    invoiceSymbol;

  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  useEffect(() => {
    setCommonStatus(getInvoiceStatus(t));
  }, [t]);

  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);

  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);
  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);
  // modalTypeSign
  const [transferData, setTransferData] = useState(null);
  const [modalTypeSign, setModalTypeSign] = useState(false);
  const toggleTypeSignModal = () => setModalTypeSign(!modalTypeSign);
  // modalUSB
  const [modalUSBSign, setModalUSBSign] = useState(false);
  const toggleUSBSignModal = () => setModalUSBSign(!modalUSBSign);
  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);
  // Confirm Cancel modal
  const [modalConfirmCancel, setModalConfirmCancel] = useState(false);
  const toggleConfirmCancelModal = () =>
    setModalConfirmCancel(!modalConfirmCancel);
  // CompareInvoiceModal
  const [dataCompare, setDataCompare] = useState(null);
  const [modalCompareInvoice, setModalCompareInvoice] = useState(false);
  const toggleCompareInvoiceModal = () =>
    setModalCompareInvoice(!modalCompareInvoice);
  // modalConfirmAction (Replace or Adjust invoice)
  const [dataConfirmAction, setDataConfirmAction] = useState(null);
  const [modalConfirmAction, setModalConfirmAction] = useState(false);
  const toggleConfirmActionModal = () =>
    setModalConfirmAction(!modalConfirmAction);
  // modalErrorRelease
  const [idRelease, setIdRelease] = useState(null);
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);
  // modalHistoryTransfer
  const [idHistory, setIdHistory] = useState(null);
  const [modalHistoryTransfer, setModalHistoryTransfer] = useState(false);
  const toggleHistoryTransferModal = () =>
    setModalHistoryTransfer(!modalHistoryTransfer);
  // modalHSM
  const [modalHSMSign, setModalHSMSign] = useState(false);
  const toggleHSMSignModal = () => setModalHSMSign(!modalHSMSign);

  const Dashboard = useSelector(state => state.Dashboard);
  const {
    tenantCodeHeader,
    finalBuInfo,
    type: typeDashboard,
    buStoreHeader,
    finalListBuCode,
  } = Dashboard;

  const [isEnterprise, setIsEnterprise] = useState(false);
  useEffect(() => {
    if (tenantCodeHeader) {
      setIsEnterprise(tenantCodeHeader === TENANT_CODE.GUARDIAN);
    }
  }, [tenantCodeHeader]);

  // Action list chang tenantCode
  const [isCheckChangeStore, setIsCheckChangeStore] = useState(false);
  useEffect(() => {
    if (typeDashboard === SET_BU_STORE_HEADER) {
      setIsCheckChangeStore(true);
    }
    if (typeDashboard === SET_BU_STORE_HEADER_SUCCESS && isCheckChangeStore) {
      issueInvoiceList.params.page = 1;
      issueInvoiceList.params.columnFilter = {
        ...issueInvoiceList.params.columnFilter,
        ...filterList,
        "filter[invoice_type]": finalBuInfo?.invoice_type,
      };
      dispatch(
        listIssueInvoice(
          issueInvoiceList.params,
          TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY
        )
      );
      dispatch(resetSetBuStoreHeader());
      getListInvoiceSymbol(KHMSHDON.WAREHOUSE_AGENCY);
    }
  }, [typeDashboard]);

  useEffect(() => {
    if (successClone && tenantCodeHeader) {
      issueInvoiceList.params.page = 1;
      issueInvoiceList.params.columnFilter = {
        ...issueInvoiceList.params.columnFilter,
        ...filterList,
      };
      dispatch(
        listIssueInvoice(
          issueInvoiceList.params,
          TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY
        )
      );
      addToast("Đã nhân bản tờ hóa đơn", {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(resetCloneEnvoice());
    }
  }, [successClone, tenantCodeHeader]);

  // Get list KHHD
  const getListInvoiceSymbol = ttchung_khmshdon => {
    invoiceSymbolList.params.page = -1;
    invoiceSymbolList.params.sort = "name";
    invoiceSymbolList.params.columnFilter = {
      "filter[record_status]": "O",
      "filter[bu_code]": localStorage.getItem(BU_STORE_HEADER),
      "filter[khmhdon]": ttchung_khmshdon,
    };
    invoiceSymbolList.params.fields =
      "id,khmhdon,khhdon,bu_code,record_status,tenant_code,";
    dispatch(listInvoiceSymbol(invoiceSymbolList.params));
  };

  // Action list And Change Language
  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    issueInvoiceList.params.page = 1;
    issueInvoiceList.params.sizePerPage = 10;
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filterList,
    };

    initColumn();
    return () => {
      dispatch(resetListIssueInvoice());
    };
  }, [dispatch, t]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (issueInvoiceList) {
      setColumnsTable(initColumns);
    }

    if (issueInvoiceList.columnsVisibleHaveCode) {
      initColumn();
    }
  }, [issueInvoiceList]);

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [isRoleStore, setIsRoleStore] = useState(false);

  // Action Dispatch
  useEffect(() => {
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const roleUser = info["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
    }
  }, []);

  // Error Dispatch
  useEffect(() => {
    if (errorList && errorList.message) {
      addToast(errorList.message, {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetListIssueInvoice());
    }

    if (errorInvoiceSymbolList) {
      addToast(
        errorInvoiceSymbolList.message ||
          t("message.list", {
            target: t("invoice_symbol"),
            status: t("message.error"),
          }),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      dispatch(resetListInvoiceSymbol());
    }
  }, [addToast, dispatch, errorInvoiceSymbolList, errorList, t]);

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS: {
        if (!modalUSBSign) {
          if (fileDownload !== null) {
            const link = document.createElement("a");
            link.href = fileDownload;
            link.setAttribute("download", fileDownloadName);
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
        }

        dispatch(resetDownloadXmlIssueInvoice());
        break;
      }
      case DOWNLOAD_XML_ISSUE_INVOICE_FAIL:
        if (!modalUSBSign) {
          console.log("jhahaha222233");
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlIssueInvoice());
        break;
      case REPLACE_ISSUE_INVOICE_SUCCESS:
        addToast("Lập hóa đơn thay thế thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleDetailModal();
        resetDataFunc();
        dispatch(resetReplaceIssueInvoice());
        break;
      case REPLACE_ISSUE_INVOICE_FAIL:
        addToast("Lập hóa đơn thay thế thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetReplaceIssueInvoice());
        break;

      case ADJUST_ISSUE_INVOICE_SUCCESS:
        addToast("Lập hóa đơn điều chỉnh thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleDetailModal();
        resetDataFunc();
        dispatch(resetAdjustIssueInvoice());
        break;
      case ADJUST_ISSUE_INVOICE_FAIL:
        addToast("Lập hóa đơn điều chỉnh thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetAdjustIssueInvoice());
        break;

      case DELETE_ISSUE_INVOICE_SUCCESS:
        addToast("Xóa hóa đơn thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmDeleteModal();
        resetDataFunc();
        dispatch(resetDeleteIssueInvoice());
        break;
      case DELETE_ISSUE_INVOICE_FAIL:
        addToast("Xóa hóa đơn thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDeleteIssueInvoice());
        break;

      case CANCEL_ISSUE_INVOICE_SUCCESS:
        addToast("Gửi yêu cầu hủy hóa đơn thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmCancelModal();
        resetDataFunc();
        dispatch(resetCancelIssueInvoice());
        break;
      case CANCEL_ISSUE_INVOICE_FAIL:
        addToast("Gửi yêu cầu hủy hóa đơn thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCancelIssueInvoice());
        break;
      case EXPORT_INVOICE_WAREHOUSES_AGENCY_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetExportInvoiceWarehousesAgency());
        break;
      }
      case EXPORT_INVOICE_WAREHOUSES_AGENCY_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetExportInvoiceWarehousesAgency());
        break;
      default:
        break;
    }
  }, [type]);

  const initColumn = () => {
    if (issueInvoiceList.columnsVisible) {
      for (const item of initColumns) {
        if (issueInvoiceList.columnsVisible[item.dataField] !== undefined) {
          item.hidden = !issueInvoiceList.columnsVisible[item.dataField];
        }
      }
    }
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    // dispatch(setListVATInvoiceHaveCodeColumn(field, value));
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    issueInvoiceList.params.sort = sortField
      ? sortOrder + sortField
      : issueInvoiceList.params.sort;
    issueInvoiceList.params.columnFilter =
      { ...columnFilter, ...filterList } || {};
    issueInvoiceList.params.page = page || 1;
    issueInvoiceList.params.sizePerPage = sizePerPage || 10;
    dispatch(
      listIssueInvoice(
        issueInvoiceList.params,
        TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY
      )
    );
  };

  const onSearchAllHandle = value => {
    issueInvoiceList.params.keywords = value;
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filterList,
    };
    dispatch(
      listIssueInvoice(
        issueInvoiceList.params,
        TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY
      )
    );
  };

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
    switch (modeSet) {
      case issueInvoiceModeList.CREATE_WAREHOUSE_AGENCY_DETAIL:
      case issueInvoiceModeList.EDIT_WAREHOUSE_AGENCY_DETAIL:
        issueInvoiceList.params.page = 1;
        issueInvoiceList.params.sizePerPage = 10;
        issueInvoiceList.params.columnFilter = {
          ...issueInvoiceList.params.columnFilter,
          ...filterList,
        };
        dispatch(
          listIssueInvoice(
            issueInvoiceList.params,
            TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY
          )
        );
        break;
      default:
        break;
    }
  };

  const toastAddInvoice = () => {
    return addToast("Bạn chưa đăng ký sử dụng loại hóa đơn này", {
      appearance: "error",
      autoDismiss: true,
    });
  };

  const createInvoiceHanler = () => {
    if (toastWarningIsAllStore(addToast)) {
      return;
    }
    if (finalBuInfo) {
      if (finalBuInfo.ctu === 1) {
        actionCreate();
      } else {
        toastAddInvoice();
      }
    }
  };

  const actionCreate = () => {
    setDataConfirmAction(null);
    setDataDetail({});
    switch (pageView) {
      case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_NONE_CODE:
        setMode(issueInvoiceModeList.CREATE_WAREHOUSE_AGENCY_DETAIL);
        break;
      default:
        break;
    }
    toggleDetailModal();
  };
  const showPdfById = id => {
    setDataViewDocument({
      id,
    });
    togglePdfViewModal();
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      getListInvoiceSymbol(row.ttchung_khmshdon);
      setDataConfirmAction({
        typeAdjust: row.adjust_mod,
      });
      setDataDetail({
        id: row.id,
        tthdlquan_tchdon: row.tthdlquan_tchdon,
        root: row.root,
        child: row.child,
        tthdlquan_lhdclquan: row.tthdlquan_lhdclquan,
        tthdlquan_khmshdclquan: row.tthdlquan_khmshdclquan,
        tthdlquan_khhdclquan: row.tthdlquan_khhdclquan,
        tthdlquan_shdclquan: row.tthdlquan_shdclquan,
        tthdlquan_nlhdclquan: row.tthdlquan_nlhdclquan,
      });
      switch (pageView) {
        case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_HAVE_CODE:
        case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_NONE_CODE:
          setMode(issueInvoiceModeList.VIEW_WAREHOUSE_AGENCY_DETAIL);
          break;
        default:
          break;
      }
      toggleDetailModal();
    },
  };
  const cloneEnvoice = id => {
    dispatch(getCloneEnvoice(id, TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY));
  };
  const listRowAction = [
    {
      icon: <i className="bx bx-history font-size-18 text-success" />,
      text: "Lịch sử truyền nhận",
      onClick: row => {
        setIdHistory(row.id);
        toggleHistoryTransferModal();
      },
    },
    {
      icon: <i className="bx bx-send font-size-18 text-success" />,
      text: "Phát hành phiếu",
      //   isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      conditionVisible: {
        resource_id: [],
        auth_status: [AUTH_STATUS_NEW, AUTH_STATUS_RR],
      },
      onClick: row => {
        if (toastWarningIsAllStore(addToast)) {
          return;
        }
        setTransferData({
          id: row.id,
          mst: row.nban_mst,
          resource_id: getResourceIdXML(row.resource_list, "raw"),
          type: TYPE_TRANSFER.INVOICE,
          invoice_type: row.invoice_type,
        });
        toggleTypeSignModal();
      },
    },
    {
      icon: <i className="bx bx-edit font-size-18 text-success" />,
      text: "Cập nhật hóa đơn",
      //   isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      conditionVisible: {
        ttchung_shdon: [null],
        auth_status: [AUTH_STATUS_NEW, AUTH_STATUS_RR],
      },
      onClick: row => {
        if (row.tthdlquan_tchdon) {
          let mode = null;
          switch (row.tthdlquan_tchdon) {
            case "1":
              mode = MODE_INVOICE_ACTION.REPLACE;
              break;
            case "2":
              mode = MODE_INVOICE_ACTION.ADJUST;
              break;
            default:
              break;
          }
          setDataConfirmAction({
            modeEdit: mode,
            typeAdjust: row.adjust_mod,
          });
        } else {
          setDataConfirmAction(null);
        }
        setDataDetail({
          id: row.id,
          tthdlquan_tchdon: row.tthdlquan_tchdon,
          root: row.root,
          child: row.child,
          tthdlquan_lhdclquan: row.tthdlquan_lhdclquan,
          tthdlquan_khmshdclquan: row.tthdlquan_khmshdclquan,
          tthdlquan_khhdclquan: row.tthdlquan_khhdclquan,
          tthdlquan_shdclquan: row.tthdlquan_shdclquan,
          tthdlquan_nlhdclquan: row.tthdlquan_nlhdclquan,
        });
        switch (pageView) {
          case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_HAVE_CODE:
          case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_NONE_CODE:
            setMode(issueInvoiceModeList.EDIT_WAREHOUSE_AGENCY_DETAIL);
            break;
          default:
            break;
        }
        toggleDetailModal();
      },
    },
    {
      icon: <i className="bx bx-download font-size-18 text-primary" />,
      text: "Download XML",
      conditionVisible: {
        resource_id: [],
      },
      onClick: row => {
        let resource_id = null;
        let type = "";
        let mltdiep = null;
        if (row.auth_status === AUTH_STATUS_NEW) {
          type = "raw";
        } else if (row.auth_status === AUTH_STATUS_APPROVE) {
          type = "tct-response";
          switch (row.invoice_type) {
            // có mã
            case "1":
              mltdiep = "202";
              break;
            // không mã
            case "0":
              mltdiep = "204";
              break;
            default:
              break;
          }
        } else {
          type = "signed";
        }
        resource_id = getResourceIdXML(row.resource_list, type, mltdiep);
        if (resource_id) {
          dispatch(
            downloadXmlIssueInvoice(
              resource_id,
              row.ttchung_thdon,
              "blob",
              TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY
            )
          );
        } else {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      },
    },
    {
      icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
      text: "Xem trước bản hiển thị",
      onClick: row => {
        showPdfById(row.id);
      },
    },
    {
      icon: <i className="bx bx-trash font-size-18 text-danger" />,
      text: "Hủy",
      //   isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      conditionVisible: {
        auth_status: [AUTH_STATUS_APPROVE, AUTH_STATUS_REPLACE],
        link_type: [null],
      },
      onClick: row => {
        setDataViewDocument({
          id: row.id,
          gui_hdth: row.gui_hdth,
        });
        toggleConfirmCancelModal();
      },
    },
    {
      icon: <i className="bx bx-trash font-size-18 text-danger" />,
      text: "Xóa bỏ",
      //   isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      conditionVisible: {
        ttchung_shdon: [null],
        auth_status: [AUTH_STATUS_NEW],
      },
      onClick: row => {
        setDataViewDocument({
          id: row.id,
        });
        toggleConfirmDeleteModal();
      },
    },
    {
      icon: <i className="bx bx-rotate-left font-size-18 text-primary" />,
      text: "Thay thế",
      isCurrentMonthOnly: isRoleStore,
      //   isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      conditionVisible: COMMON_CONDITION_VISIBLE.REPLACE,
      onClick: row => {
        setDataConfirmAction({
          id: row.id,
          mode: MODE_INVOICE_ACTION.REPLACE,
          pattern: row.ttchung_khmshdon,
          serial: row.ttchung_khhdon,
          invoiceNo: row.ttchung_shdon,
          nlap: row.ttchung_nlap,
        });
        toggleConfirmActionModal();
      },
    },
    {
      icon: <i className="bx bx-edit font-size-18 text-primary" />,
      text: "Điều chỉnh",
      //   isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      conditionVisible: COMMON_CONDITION_VISIBLE.ADJUST,
      onClick: row => {
        setDataConfirmAction({
          id: row.id,
          mode: MODE_INVOICE_ACTION.ADJUST,
          pattern: row.ttchung_khmshdon,
          serial: row.ttchung_khhdon,
          invoiceNo: row.ttchung_shdon,
          nlap: row.ttchung_nlap,
        });
        toggleConfirmActionModal();
      },
    },
    {
      icon: <i className="fas fa-copy font-size-16 text-success"></i>,
      isShow: finalBuInfo?.can_clone === 1,
      text: "Copy hóa đơn này",
      conditionVisible: {
        tthdlquan_tchdon: [null],
      },
      onClick: row => {
        cloneEnvoice(row.id);
      },
    },
    // {
    //   icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
    //   text: "Download PDF",
    //   conditionVisible: {
    //     resource_id: [],
    //   },
    //   onClick: row => {},
    // },
  ];

  const actionReplaceOrAdjustInvoice = (typeAdjust, finalSerial) => {
    setDataConfirmAction({
      ...dataConfirmAction,
      typeAdjust,
      finalSerial,
    });
    setDataDetail({ id: dataConfirmAction.id });
    switch (pageView) {
      case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_NONE_CODE:
        setMode(issueInvoiceModeList.EDIT_WAREHOUSE_AGENCY_DETAIL);
        break;
      default:
        break;
    }
    toggleDetailModal();
  };

  const listMultipleRowAction = [
    {
      icon: <i className="far fa-file-excel font-size-18 text-success" />,
      text: "Xuất danh sách phiếu xuất kho",
      isLoading: exportInvoiceWarehousesAgencyData.loading,
      loadingText: "Đang xuất danh sách phiếu xuất kho",
      onClick: data => {
        let objectExport = exportFormatData();
        objectExport = {
          ...objectExport,
          ...issueInvoiceList.params.columnFilter,
          sort: issueInvoiceList.params.sort
            ? issueInvoiceList.params.sort
            : "-checker_date",
          keywords: issueInvoiceList.params.keywords,
        };
        dispatch(
          exportInvoiceWarehousesAgency(
            objectExport,
            getFileNameExcel("DanhSachPhieuXuatKhoGuiBanDaiLy")
          )
        );
      },
    },
  ];

  const exportFormatData = () => {
    let objectExport = {};
    columnsTable
      .filter(item => item.hidden === false || item.hidden === undefined)
      .map(item => {
        const formatData = {
          id: item.id,
          dataField: item.dataField,
          hidden: item.hidden,
          text: item.text,
        };

        const key = `columns[${formatData.dataField}][label]`;
        // Format data
        switch (formatData.dataField) {
          case "auth_status":
            for (const key in selectFilterAuthStatus) {
              objectExport[
                `columns[${formatData.dataField}][mapping][${key}]`
              ] = selectFilterAuthStatus[key];
            }
            break;
          //   case "approve_status":
          //     for (const key in selectFilterApproveStatus) {
          //       objectExport[
          //         `columns[${formatData.dataField}][mapping][${key}]`
          //       ] = selectFilterApproveStatus[key];
          //     }
          //     break;
          case "sent":
            objectExport[`columns[${formatData.dataField}][mapping][0]`] =
              "Chưa gửi mail";
            objectExport[`columns[${formatData.dataField}][mapping][1]`] =
              "Đã gửi mail";
            break;
          case "ttchung_khmshdon":
            objectExport[`columns[${formatData.dataField}][mapping][1]`] =
              "HÓA ĐƠN GTGT";
            objectExport[`columns[${formatData.dataField}][mapping][2]`] =
              "HÓA ĐƠN BH";
            break;
          case "ttchung_shdon":
            objectExport[`columns[${formatData.dataField}][mapping][null]`] =
              "Chờ cấp số";
            break;
          case "ttchung_nlap":
            objectExport[`columns[${formatData.dataField}][type]`] = "date";
            break;
          case "ttoan_tgtttbso":
            objectExport[`columns[${formatData.dataField}][type]`] = "currency";
            break;
          default:
            break;
        }
        // Format style
        switch (formatData.dataField) {
          case "nmua_ten":
            objectExport[
              `columns[${formatData.dataField}][contentOptions][alignment][wrapText]`
            ] = true;
            objectExport[
              `columns[${formatData.dataField}][dimensionOptions][width]`
            ] = 80;
            break;
          default:
            objectExport[
              `columns[${formatData.dataField}][dimensionOptions][autoSize]`
            ] = true;
            break;
        }
        //
        const value = formatData.text;
        objectExport[key] = value;

        return formatData;
      });
    return objectExport;
  };

  const getAuthStatus = row => {
    let status = row.auth_status;
    let id = row.id;
    let child = row.child;
    let root = row.root;
    let infoError = null;
    let info = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    info = getRowInvoiceReplaceAdjustInfo(
      row,
      setDataCompare,
      dispatch,
      getDataLink,
      toggleCompareInvoiceModal
    );
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
          {infoError}
          {info}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Đã phát hành",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành",
    // [AUTH_STATUS_REPLACE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REPLACE]?.text, // "Thay thế",
    // [AUTH_STATUS_EDIT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_EDIT]?.text, // "Điều chỉnh",
    [AUTH_STATUS_CANCEL_WAITING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL_WAITING]?.text, // "Hủy",
    [AUTH_STATUS_CANCEL]: commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL]?.text, // "Hủy",
    [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text, // Đã tiếp nhận đăng ký
    [AUTH_STATUS_ARE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_ARE]?.text, // Đã tiếp nhận thay đổi

    [AUTH_STATUS_RR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RR]?.text, //"Từ chối tiếp nhận đăng ký",
    [AUTH_STATUS_RRE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RRE]?.text, //"Từ chối tiếp nhận thay đổi"
  };

  const getClientType = row => {
    let client_type = row.client_type;
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.CLIENT_TYPE[client_type]?.badgeColor}`}
            pill
          >
            {commonStatus?.CLIENT_TYPE[client_type]?.text}
          </Badge>
        </div>
      </React.Fragment>
    );
  };

  const getSelectFilterClientType = () => {
    return selectFilterClientType;
  };

  const selectFilterClientType = {
    // [CLIENT_TYPE_CONST.SALE]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.SALE]?.text,
    // [CLIENT_TYPE_CONST.SALE_ADJ]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.SALE_ADJ]?.text,
    // [CLIENT_TYPE_CONST.IBT_GTGT]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT_GTGT]?.text,
    // [CLIENT_TYPE_CONST.GRA]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.GRA]?.text,
    // [CLIENT_TYPE_CONST.GRA_ADJ]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.GRA_ADJ]?.text,
    [CLIENT_TYPE_CONST.IBT]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT]?.text,
    [CLIENT_TYPE_CONST.IBT_CSM]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT_CSM]?.text,
  };

  const initColumns = [
    // {
    //   dataField: "pban",
    //   text: t("table.version"),
    //   // sort: true,
    //   // filter: textFilter({
    //   //   placeholder: t("placeholder.enter", {
    //   //     title: t("table.message_sender"),
    //   //   }),
    //   // }),
    // },
    {
      dataField: "id",
      text: "id",
      sort: true,
      hidden: env.API_AIR_BRAKE_ENV !== "dev" || isEnterprise,
    },
    {
      dataField: "bu_code",
      text: "Mã đơn vị",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { maxWidth: "120px" },
      }),
      //   hidden: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU || isEnterprise,
    },
    {
      dataField: "client_ref_uuid",
      text: "Số tham chiếu",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "120px" },
      }),
      formatter: (cell, row) => {
        return (
          <div style={{ maxWidth: "120px", whiteSpace: "initial" }}>{cell}</div>
        );
      },
    },
    {
      dataField: "ttchung_thdon",
      text: t("table.invoice_name"),
      sort: true,
      hidden: isEnterprise,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "auth_status",
      text: t("auth_status.name"),
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterAuthStatus,
        style: { maxWidth: "129px" },
      }),
    },
    {
      dataField: "ttchung_khmshdon",
      text: t("table.invoice_model_number_symbol"),
      hidden: true,
    },
    {
      dataField: "ttchung_khhdon",
      text: t("table.invoice_symbol"),
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "ttchung_shdon",
      text: "Số HĐ",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      formatter: (cellContent, row) => {
        return cellContent !== "0" && cellContent ? cellContent : "Chờ cấp số";
      },
    },
    {
      dataField: "ttchung_nlap",
      text: t("table.date_created"),
      formatter: (cellContent, row) => tableFormateDate(row.ttchung_nlap),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={issueInvoiceList.params.columnFilter}
        />
      ),
    },
    {
      dataField: "nmua_mst",
      text: t("form.nmua_mst"),
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      hidden: isEnterprise,
    },
    {
      dataField: "nmua_ten",
      text: t("form.nmua_ten"),
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "150px" },
      }),
      formatter: (cell, row) => {
        return (
          <div style={{ width: "150px", whiteSpace: "initial" }}>{cell}</div>
        );
      },
    },
    {
      dataField: "maker.display_name",
      text: t("table.maker_id"),
      sort: true,
      hidden: isEnterprise,
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      hidden: isEnterprise,
      sort: true,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={issueInvoiceList.params.columnFilter}
        />
      ),
    },
    {
      dataField: "client_type",
      text: "Nguồn",
      hidden: !isEnterprise,
      formatter: (cellContent, row) => getClientType(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: getSelectFilterClientType(),
        style: { width: "138px" },
      }),
    },
  ];

  const resetDataFunc = (showLoading = true) => {
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filterList,
    };
    dispatch(
      listIssueInvoice(
        issueInvoiceList.params,
        TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY,
        showLoading
      )
    );
  };

  return (
    <React.Fragment>
      <div className="page-content badge-soft ">
        <MetaTags>
          <title>{t(title)}</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title={t(titleManger)}
            breadcrumbItem={t(title) + ` (${issueInvoiceList.totalCount})`}
          />
          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              <AutoReloadList
                listData={issueInvoiceList.items}
                dataCheck={bkDataNew}
                actionReset={() => {
                  dispatch(resetBackupDataNew());
                }}
                actionReload={() => {
                  resetDataFunc(false);
                }}
              />
              {/* Deny modal */}
              <ConfirmModal
                isOpen={modalConfirmDelete}
                titleHeader={"Xác nhận xóa hóa đơn"}
                titleBody={"Hệ thống sẽ thực hiện xóa hóa đơn này ?"}
                isDisableButton={deleteInvoice.loading}
                onConfirm={note => {
                  dispatch(
                    deleteIssueInvoice(
                      dataViewDocument.id,
                      TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY
                    )
                  );
                }}
                textBtnConfirm={"Xác nhận"}
                textBtnCancel={"Đóng"}
                toggle={toggleConfirmDeleteModal}
              />
              {/* Cancel modal */}
              <ConfirmCancelInvoiceModal
                isOpen={modalConfirmCancel}
                titleHeader={"Xác nhận gửi thông báo hủy hóa đơn"}
                titleBody={"Nhập lí do hủy hóa đơn ?"}
                isDisableButton={cancelInvoice.loading}
                isRequireNote={false}
                isHaveNote={true}
                onConfirm={(note, listUploadId) => {
                  let type = undefined;
                  if (dataViewDocument.gui_hdth === 1) {
                    type = 1;
                  }
                  dispatch(
                    cancelIssueInvoice(
                      [{ id: dataViewDocument.id, ldo: note }],
                      type,
                      TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY,
                      listUploadId
                    )
                  );
                }}
                textBtnConfirm={"Xác nhận"}
                textBtnCancel={"Đóng"}
                toggle={toggleConfirmCancelModal}
              />
              <ConfirmActionInvoice
                confirmActionData={dataConfirmAction}
                isOpen={modalConfirmAction}
                toggle={toggleConfirmActionModal}
                actionReplaceOrAdjustInvoice={actionReplaceOrAdjustInvoice}
              />
              <CompareInvoiceModal
                setDataCompare={setDataCompare}
                showPdfById={showPdfById}
                dataCompare={dataCompare}
                isOpen={modalCompareInvoice}
                toggle={toggleCompareInvoiceModal}
              />
              {/* PDFViewModal */}
              <PDFViewModal
                isOpen={modalPdfView}
                dataViewDocument={dataViewDocument}
                toggle={togglePdfViewModal}
              ></PDFViewModal>
              {/* ErrorReleaseModal */}
              <ErrorReleaseModal
                isOpen={modalErrorRelease}
                toggle={toggleErrorReleaseModal}
                id={idRelease}
                path={"invoice-tickets"}
              />
              {/* HistoryTransferModal */}
              <HistoryTransferModal
                isOpen={modalHistoryTransfer}
                toggle={toggleHistoryTransferModal}
                id={idHistory}
                path={"invoice-tickets"}
              />
              {/* Detail Modal */}
              <DetailData
                dataDetail={dataDetail}
                dataConfirmAction={dataConfirmAction}
                isOpenModal={detailModal}
                toggleModal={toggleDetailModal}
                mode={mode}
                pageView={pageView}
                showPdfById={showPdfById}
                khhdonDefault={khhdonDefault}
                typeInvoiceAnother={TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY}
                invoiceSymbolList={invoiceSymbolList.items}
                setKhhdonDefault={setKhhdonDefault}
                setPageView={setPageView}
              />
              {/* Hình thức ký modal */}
              <TypeSignDigitalModal
                t={t}
                isOpen={modalTypeSign}
                typeInvoiceAnother={TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY}
                transferData={transferData}
                toggle={toggleTypeSignModal}
                toggleUSBSignModal={toggleUSBSignModal}
                toggleHSMSignModal={toggleHSMSignModal}
              />
              {/* Ký USB Modal */}
              <VerifyPinUSBModal
                t={t}
                isOpen={modalUSBSign}
                downloadXmlFunc={downloadXmlIssueInvoice}
                typeInvoiceAnother={TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY}
                transferData={transferData}
                resetDataFunc={resetDataFunc}
                toggle={toggleUSBSignModal}
              />
              {/* Ký HSM Modal */}
              <SignHSMModal
                t={t}
                isOpen={modalHSMSign}
                invoice_type={transferData?.invoice_type}
                transferData={transferData}
                typeInvoiceAnother={TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY}
                resetDataFunc={resetDataFunc}
                releaseFunc={releaseIssueInvoice}
                resetReleaseFunc={resetReleaseIssueInvoice}
                toggle={toggleHSMSignModal}
              />
            </Col>
            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                <CardBody>
                  <RemoteDataTable
                    // selectRow={selectRowCheckbox}
                    // onRowsSelect={onRowsSelect}
                    // expandRow={expandRowTable}
                    keyField="id"
                    data={issueInvoiceList.items}
                    columns={columnsTable}
                    page={issueInvoiceList.params.page}
                    sizePerPage={issueInvoiceList.params.sizePerPage}
                    totalSize={issueInvoiceList.totalCount}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    optionShowColumnHandel={optionShowColumnHandler}
                    rowEvents={rowEventsHandler}
                    listMultipleRowAction={listMultipleRowAction}
                    listRowAction={
                      isRoleStore
                        ? listRowAction.filter(
                            item =>
                              item.text !== "Phát hành phiếu" &&
                              item.text !== "Hủy"
                          )
                        : listRowAction
                    }
                    loading={loadingList}
                  >
                    <Button
                      type="button"
                      color="primary"
                      className="me-2 btn-label"
                      onClick={createInvoiceHanler}
                    >
                      <i className="bx bx-plus label-icon" />
                      {t("table.btn_create_bill")}
                    </Button>
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

ListData.propTypes = {
  filterList: PropTypes.object.isRequired,
  pageView: PropTypes.string,
  title: PropTypes.string,
  titleManger: PropTypes.string,
  khhdonDefault: PropTypes.string,
  setKhhdonDefault: PropTypes.any,
  setPageView: PropTypes.any,
};

ListData.defaultProps = {
  filterList: {},
  pageView: "",
};

export default ListData;
